export default __webpack_public_path__ + "static/auth-bg-0ad2a6065f813ee3c678842fceb21f79.jpg";